import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { firstValueFrom } from 'rxjs';
import { PaginationListResponse } from 'src/app/_models/pagination-list-response';
import { GetEmpresaListaOfertasActivasResponse } from '../../empresa/responses/get-ofertas-activas-emp-response';
import { GetDetallesEmpresaResponse } from '../responses/get-detalles-empresa-response';
import { AdminService } from '../services/admin.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AdmModalValidarofertasEmpresaComponent } from '../adm-modal-validarofertas-empresa/adm-modal-validarofertas-empresa.component';
import { UpdateEstadoValidacionOfertaEmpresaRequest } from '../requests/update-estado-validacion-oferta-empresa-request';

@Component({
  selector: 'app-adm-empresas-ofdetalle',
  templateUrl: './adm-empresas-ofdetalle.component.html',
  styleUrls: ['./adm-empresas-ofdetalle.component.css']
})
export class AdmEmpresasOfdetalleComponent implements OnInit {
  datosEmpresa;
  validResult = false;
  validResultOffers = false;

  data: GetDetallesEmpresaResponse;
  dataOfertas : PaginationListResponse<GetEmpresaListaOfertasActivasResponse>; 
  currentPage : number=1;
  public basicColorBorderCollapse1 = true;

  constructor(private _route: ActivatedRoute,
              private router : Router,
              private toastr : ToastrService,
              private adminService : AdminService,
              private modalService: NgbModal){
  }

  async ngOnInit() 
  {
    this._route.queryParams.subscribe((params) => {
      if (params.empresa) {
        this.datosEmpresa = JSON.parse(params.empresa);
      }
    });
    this.validResult = await this.DetallesEmpresa();
    this.validResultOffers = await this.getListOfertasPublicadasEmpresa();
    if(!this.datosEmpresa  || !this.validResult || !this.validResultOffers)
    {
      this.toastr.error('No se ha podido recuperar la información relacionada a la empresa.','Error');
      this.router.navigate(['/onlyadminaccess/empresas'], 
      {
        queryParams: {},
        skipLocationChange: true
      });
    }
  }

  async DetallesEmpresa() : Promise<boolean>
  {
    try 
    {
      this.data = await firstValueFrom(this.adminService.getDetallesEmpresa(this.datosEmpresa.idUsuario));
      if(this.data)
      {
        this.datosEmpresa = this.data;
        this.toastr.success('Ya puedes revisar los detalles.','Datos Obtenidos');
        return true;
      }
    } catch (error) {
      return false;
    }
  }

  async getListOfertasPublicadasEmpresa() : Promise<boolean>
  {
    try 
    {
      const result = await firstValueFrom(this.adminService.getOfertasPublicadasEmpresa(this.datosEmpresa.idUsuario));
      if(result && result.data && result.totalPages>0 &&result.totalRows>0)
      {
        this.dataOfertas = result;
        return true;
      }
      if(result && result.totalPages==0 &&result.totalRows==0)
      {
        this.toastr.info('No existen registros de ofertas de trabajo publicadas por este usuario.','Aviso');
        return true;
      }
      else
      this.toastr.info('No existen registros de ofertas de trabajo publicadas por este usuario.','Aviso');
    } 
    catch (error) {
      // manejar el error
    }
      return false;
  }

  openDetailOffer(idOferta:number) {
    if(idOferta>0)
    {
      this.router.navigate(['onlyadminaccess/ofertas/detalle'], {
        queryParams: { idOferta: JSON.stringify(idOferta) },
        skipLocationChange: true //skip location para ocultar el json de la URL
      });
    }
    else
      this.toastr.error('No se han podido abrir los detalles de la oferta de trabajo. Inténtalo de nuevo.','Error');
  }

  async updateEstadoValidacionOferta()
  {
    const modalRef = this.modalService.open(AdmModalValidarofertasEmpresaComponent,{ windowClass: 'animated fadeInUp',keyboard:false,backdrop: false });
    const mensajeValidacion = 'El estado cambiará a "Puede publicar sin revisión", lo que significa que las ofertas creadas por este usuario empresa serán publicadas de inmediato y los egresados podrán visualizarlas, sin necesidad de que el administrador las revise y valide su publicación.';
    const mensajeRequiereRevision = 'El estado cambiará a "Requiere revisión", lo que significa que todas las ofertas creadas por este usuario empresa necesitan pasar por un proceso de revisión y validación antes de ser publicadas, este proceso debe realizarlo un administrador.';
    modalRef.componentInstance.title = 'Actualizar validación para publicación de ofertas';
    modalRef.componentInstance.message = this.data.requerirValidacion ? mensajeValidacion : mensajeRequiereRevision;
    modalRef.componentInstance.additional = 'Si desea revetir el cambio, en cualquier momento puede actualizar nuevamente el estado de validación para publicación de ofertas de la empresa.';
    modalRef.result.then(async (result) => {
      if (result === 'accept') 
      {// El usuario ha aceptado el modal
        try
        {
          const dataBinded = this.dataBinding();
          if(!dataBinded)
            return;
          const result = await firstValueFrom(this.adminService.updateEstadoValidacionOfertaEmpresa(dataBinded));
          if(!result)
              {
                this.toastr.error('No fue posible actualizar la validación. Inténtalo de nuevo.','Error');
                return;
              }
              this.toastr.success('El estado de validación de las ofertas se ha actualizado.','Cambios guardados');
              this.data = await firstValueFrom(this.adminService.getDetallesEmpresa(this.datosEmpresa.idUsuario));
        }
        catch (error) {
          // manejar el error
        }
          return false;
      }
    }, (reason) => {
      // El usuario ha cerrado el modal sin hacer clic en ningún botón
    });
  }

  dataBinding()
  {
    let UpdateEstadoValidacionOfertaEmpresaRequestObject : UpdateEstadoValidacionOfertaEmpresaRequest = {} as UpdateEstadoValidacionOfertaEmpresaRequest;
    UpdateEstadoValidacionOfertaEmpresaRequestObject.idUsuario = this.data.idUsuario;
    UpdateEstadoValidacionOfertaEmpresaRequestObject.status = !this.data.requerirValidacion;
    return UpdateEstadoValidacionOfertaEmpresaRequestObject;  
  }

pageChange(page: any) {
    this.adminService
      .getOfertasPublicadasEmpresaByPage(this.datosEmpresa.idUsuario,(page - 1) * this.dataOfertas.pageSize)
      .subscribe((response) => {
        this.dataOfertas = response;
      });
  }

}
